import React from 'react';
import { Fuel } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import ValuationWizard from '../components/valuation/ValuationWizard';

export default function Valuation() {
  const location = useLocation();

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <Fuel className="w-8 h-8 text-blue-600" />
          <div>
            <h1 className="text-3xl font-bold mb-2">Gas Station Valuation</h1>
            <p className="text-gray-600">
              Get an accurate valuation for your gas station property based on comprehensive market data
            </p>
          </div>
        </div>

        <ValuationWizard key={location.key} />
      </div>
    </div>
  );
}